import React from "react";
import { format } from "date-fns";
import { Loader2, Check, Shield, X } from "lucide-react";

export const PollingScreen = () => (
  <section id="book" data-testid="payment-polling-section" className="px-6 md:px-12 lg:px-20 py-28 md:py-40 bg-[#0A0A0A]">
    <div className="max-w-2xl mx-auto text-center">
      <Loader2 size={36} className="mx-auto animate-spin text-white/70 mb-8" />
      <div className="overline mb-4">— Confirming payment</div>
      <h2 className="font-display text-3xl sm:text-4xl font-light tracking-tight">
        Just a moment.
      </h2>
      <p className="mt-4 text-white/60">We&apos;re confirming your deposit with Stripe…</p>
    </div>
  </section>
);

export const SuccessScreen = ({ booking, onReset }) => (
  <section id="book" data-testid="booking-success-section" className="px-6 md:px-12 lg:px-20 py-28 md:py-40 bg-[#0A0A0A]">
    <div className="max-w-3xl mx-auto text-center">
      <div className="inline-flex w-14 h-14 items-center justify-center border border-white/20 rounded-full mb-8">
        <Check size={22} />
      </div>
      <div className="overline mb-4">— Booking confirmed</div>
      <h2 className="font-display text-4xl sm:text-5xl font-light tracking-tight">
        See you on {format(new Date(booking.date), "EEE d MMM")} at {booking.time}.
      </h2>
      <p className="mt-6 text-white/65 leading-relaxed">
        Thanks {booking.name.split(" ")[0]} — your deposit is paid and your slot is locked in.
        We&apos;ll be in touch by phone or email shortly. A receipt has been sent to {booking.email}.
      </p>
      <div className="mt-10 inline-flex items-center gap-2 px-4 py-2 border border-white/10 text-xs tracking-[0.18em] uppercase text-white/65">
        <Shield size={13} /> Deposit refundable up to 24 hrs before
      </div>
      <div>
        <button
          type="button"
          data-testid="booking-new-button"
          onClick={onReset}
          className="mt-10 inline-flex bg-white text-black px-7 py-4 text-xs font-medium tracking-[0.22em] uppercase hover:bg-white/85"
        >
          Make another booking
        </button>
      </div>
    </div>
  </section>
);

export const FailedScreen = ({ onRetry }) => (
  <section id="book" data-testid="payment-failed-section" className="px-6 md:px-12 lg:px-20 py-28 md:py-40 bg-[#0A0A0A]">
    <div className="max-w-2xl mx-auto text-center">
      <div className="inline-flex w-14 h-14 items-center justify-center border border-red-400/40 rounded-full mb-8 text-red-300">
        <X size={22} />
      </div>
      <div className="overline mb-4 text-red-300/80">— Payment failed</div>
      <h2 className="font-display text-3xl sm:text-4xl font-light tracking-tight">
        We couldn&apos;t confirm your payment.
      </h2>
      <p className="mt-4 text-white/60">Your slot has been released. Please try again.</p>
      <button
        type="button"
        data-testid="booking-retry-button"
        onClick={onRetry}
        className="mt-8 inline-flex bg-white text-black px-7 py-4 text-xs font-medium tracking-[0.22em] uppercase hover:bg-white/85"
      >
        Try again
      </button>
    </div>
  </section>
);
